import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('adminLanguage', lng);
  };

  const currentLanguage = i18n.language || 'bg';

  return (
    <div className="flex items-center justify-center">
      <div className="flex bg-gray-100 rounded-lg p-1">
        <button
          onClick={() => changeLanguage('bg')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 ${
            currentLanguage === 'bg'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
          }`}
        >
          {t('admin.bulgarian')}
        </button>
        <button
          onClick={() => changeLanguage('en')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 ${
            currentLanguage === 'en'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
          }`}
        >
          {t('admin.english')}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
